export default "__VITE_ASSET__DJzZlPpf__"